import React from "react";
import { VStack, Box, Skeleton } from "@chakra-ui/react";

export const MarketoSkeleton = () => (
  <VStack spacing="16px" w="full" align="stretch">
    <Box display={{ base: "none", md: "flex" }} gap="16px">
      <Skeleton startColor="prosperity-stone-50" endColor="prosperity-stone-200" height="56px" w="full" borderRadius="8px" />
      <Skeleton startColor="prosperity-stone-50" endColor="prosperity-stone-200" height="56px" w="full" borderRadius="8px" />
    </Box>
    <Box display={{ base: "none", md: "flex" }} gap="16px">
      <Skeleton startColor="prosperity-stone-50" endColor="prosperity-stone-200" height="56px" w="full" borderRadius="8px" />
      <Skeleton startColor="prosperity-stone-50" endColor="prosperity-stone-200" height="56px" w="full" borderRadius="8px" />
    </Box>
    <Box display={{ base: "none", md: "flex" }} gap="16px">
      <Skeleton startColor="prosperity-stone-50" endColor="prosperity-stone-200" height="56px" w="full" borderRadius="8px" />
      <Box w="full" />
    </Box>
    <Box display={{ base: "flex", md: "none" }} flexDirection="column" gap="16px">
      <Skeleton startColor="prosperity-stone-50" endColor="prosperity-stone-200" height="56px" w="full" borderRadius="8px" />
      <Skeleton startColor="prosperity-stone-50" endColor="prosperity-stone-200" height="56px" w="full" borderRadius="8px" />
      <Skeleton startColor="prosperity-stone-50" endColor="prosperity-stone-200" height="56px" w="full" borderRadius="8px" />
      <Skeleton startColor="prosperity-stone-50" endColor="prosperity-stone-200" height="56px" w="full" borderRadius="8px" />
      <Skeleton startColor="prosperity-stone-50" endColor="prosperity-stone-200" height="56px" w="full" borderRadius="8px" />
    </Box>
    <Skeleton startColor="prosperity-stone-50" endColor="prosperity-stone-200" height="120px" w="full" borderRadius="8px" />
    <Box display="flex" alignItems="flex-start" gap="12px">
      <Skeleton startColor="prosperity-stone-50" endColor="prosperity-stone-200" height="18px" w="18px" borderRadius="4px" flexShrink={0} />
      <Skeleton startColor="prosperity-stone-50" endColor="prosperity-stone-200" height="20px" w="80%" borderRadius="4px" />
    </Box>
    <Box display="flex" justifyContent="center" mt="8px">
      <Skeleton startColor="prosperity-stone-50" endColor="prosperity-stone-200" height="56px" w={{ base: "100%", md: "200px" }} borderRadius="9999px" />
    </Box>
  </VStack>
);
